import { useState } from "react";
import { postAdvancePhase } from "works/higurashi/utils/api";

const ERROR_MESSAGE_BY_STATUS = {
  400: "現在のフェーズでは次の章へ進めません。",
  404: "状態が見つかりません。",
  409: "全クエストをクリアしてください。",
  410: "この体験はすでに終了しています。",
};
const NETWORK_ERROR_MESSAGE = "通信エラーが発生しました。再度お試しください。";
const FALLBACK_ERROR_MESSAGE = "エラーが発生しました。";

const useNextPhase = (accountKey, onAdvanced) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(FALLBACK_ERROR_MESSAGE);
  const [isLoading, setIsLoading] = useState(false);

  const onClickConfirm = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await postAdvancePhase(accountKey);
      setOpenConfirm(false);
      if (typeof onAdvanced === "function") {
        await onAdvanced();
      }
    } catch (error) {
      const status = error?.status;
      let message;
      if (status && ERROR_MESSAGE_BY_STATUS[status]) {
        message = ERROR_MESSAGE_BY_STATUS[status];
      } else if (!status) {
        message = NETWORK_ERROR_MESSAGE;
      } else {
        message = FALLBACK_ERROR_MESSAGE;
      }
      setErrorMessage(message);
      setOpenConfirm(false);
      setOpenError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const onClickProceed = () => {
    setOpenConfirm(true);
  };

  const onClickClose = () => {
    setOpenConfirm(false);
    setOpenError(false);
  };

  return {
    dialogStates: {
      openConfirm,
      openError,
    },
    isLoading,
    errorMessage,
    handlers: {
      onClickProceed,
      onClickConfirm,
      onClickClose,
    },
  };
};

export default useNextPhase;
